import { createTypes, createAction } from 'lib/action'



// *load ข้อมูลต้นแหล่ง
const SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION = createTypes(
  'sourceQualityEvaluationDashboardLoadLocation',
  'load'
)

// *laod ข้อมูลวัตถุดิบ
const SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL = createTypes(
  'sourceQualityEvaluationDashboardLoadRawMaterial',
  'load'
)

// *load table log ประเมินคุณภาพ
const SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG = createTypes(
  'sourceQualityEvaluationDashboardLoadTableLog',
  'load'
)


// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`;

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  };
}
// *load ข้อมูลต้นแหล่ง
const sourceQualityEvaluationDashboardLoadLocation = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const sourceQualityEvaluationDashboardLoadRawMaterial = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.FAITLURE),
}

// *load table log ประเมินคุณภาพ
const sourceQualityEvaluationDashboardLoadTableLog = {
  request: (data, loading) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.FAITLURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION,
  sourceQualityEvaluationDashboardLoadLocation,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL,
  sourceQualityEvaluationDashboardLoadRawMaterial,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG,
  sourceQualityEvaluationDashboardLoadTableLog,
}
